// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3-DBU","actions":"GroupTable_actions__37nPY","deleteModalFooter":"GroupTable_deleteModalFooter__3mBX-"};